import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import I18n from 'I18n';
import UsageTracker from '../../../../utils/UsageTracker';

// This component wraps a dropdown filter and provides a visual indicator of the current filter state.
// It also provides a button to clear the filter.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterButton = ({
  isFilterActive,
  onClear,
  children,
  filterType
}) => {
  const handleClear = () => {
    onClear();
    if (filterType) {
      UsageTracker.track('teamInteraction', {
        action: 'remove-filter',
        type: filterType
      });
    }
  };
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: isFilterActive ? 'fill-surface-recessed' : 'fill-transparent-default',
    borderRadius: "100",
    paddingInlineEnd: "50",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        children: children
      }), isFilterActive && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": `remove-${filterType}-filter`,
          onClick: handleClear,
          padding: "200",
          paddingInlineStart: "100",
          title: I18n.text('learningCenter.myTeam.filters.removeFilter'),
          use: "link",
          children: /*#__PURE__*/_jsx(RemoveIcon, {
            color: "icon-core-subtle"
          })
        })
      })]
    })
  });
};
export default FilterButton;